import { graphql } from "gql.tada";

export const CREATE_DRAFT_CALCULATION = graphql(`
  mutation CreateDraftCalculation($input: CreateDraftCalculationInput!) {
    createDraftCalculation(input: $input) {
      jobId
      status
      calculationId
    }
  }
`);

export const RETRY_DRAFT_CALCULATION = graphql(`
  mutation RetryDraftCalculation($jobId: ID!) {
    retryDraftCalculation(jobId: $jobId) {
      jobId
      status
    }
  }
`);

export const CALCULATION_JOB = graphql(`
  query CalculationJob($jobId: ID!) {
    calculationJob(jobId: $jobId) {
      jobId
      status
      calculationId
      summary
      errorCode
      parseOutcomes {
        uploadId
        status
        errorCode
      }
    }
  }
`);

export const REQUEST_UPLOAD = graphql(`
  mutation RequestUpload($input: RequestUploadInput!) {
    requestUpload(input: $input) {
      fileId
      uploadUrl
      status
    }
  }
`);

export const CONFIRM_UPLOAD = graphql(`
  mutation ConfirmUpload($input: ConfirmUploadInput!) {
    confirmUpload(input: $input) {
      fileId
      status
      rejectionReason
    }
  }
`);
